import React from 'react';
import './ForSale.css';

function ForSale() {
    const year = new Date().getFullYear();

    return (
        <main className="fs-page">
            <div className="fs-glow" aria-hidden="true"></div>
            <section className="fs-card">
                <div className="fs-mark">
                    <svg className="fs-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <rect x="2.5" y="4.5" width="19" height="15" rx="2.5" stroke="currentColor" strokeWidth="1.5"/>
                        <path d="M3.5 6.5 12 13l8.5-6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span className="fs-wordmark">maildrop<span className="fs-tld">.dev</span></span>
                </div>

                <h1 className="fs-title">This domain is for sale</h1>
                <p className="fs-sub">
                    <strong>maildrop.dev</strong> is available to acquire. A short, memorable name
                    for anything email or developer related.
                </p>

                <a className="fs-cta" href="mailto:domains@proteus.tech?subject=Enquiry%20about%20maildrop.dev">
                    Contact domains@proteus.tech
                </a>

                <p className="fs-note">Serious enquiries welcome.</p>
            </section>

            <footer className="fs-footer">
                © {year} Proteus Technologies Ltd.
            </footer>
        </main>
    );
}

export default ForSale;
